import creative from '../scss/creative.scss';
import popup from '../scss/popup.scss';
import ribbon from '../scss/ribbon.scss';

const styleTag = document.createElement('style');
styleTag.innerHTML = creative.toString() + popup.toString() + ribbon.toString();
document.head.appendChild(styleTag);
